import { render, staticRenderFns } from "./periodicalsSelect.vue?vue&type=template&id=1003ce36"
import script from "./periodicalsSelect.vue?vue&type=script&lang=js"
export * from "./periodicalsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports